import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AddIcon from "@mui/icons-material/Add";
import VideocamOutlinedIcon from "@mui/icons-material/VideocamOutlined";
import TextFieldsOutlinedIcon from "@mui/icons-material/TextFieldsOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import "../components/knowledgebase/knowledge-base-editor.css";
import "./landing-editor-screenshot.css";

function BrowserFrame({ title, children }) {
  return (
    <div className="landing-app-stage">
      <div className="landing-app-stage__head">
        <span className="landing-app-stage__badge">Личный кабинет InChat</span>
      </div>
      <div className="landing-ui-shot">
        <div className="landing-ui-shot__chrome">
          <span className="landing-ui-shot__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>
          <span className="landing-ui-shot__title">{title}</span>
        </div>
        <div className="landing-ui-shot__body">{children}</div>
      </div>
    </div>
  );
}

function KbTopicItem({ label, active = false }) {
  return (
    <li className={`kb-hub__list-item${active ? " kb-hub__list-item--active" : ""}`}>
      <button type="button" className="kb-hub__list-btn" tabIndex={-1}>
        <FolderOutlinedIcon fontSize="small" className="kb-hub__list-icon" />
        <span className="kb-hub__list-label">{label}</span>
      </button>
    </li>
  );
}

export function KnowledgeBaseEditorShot() {
  return (
    <BrowserFrame title="club-lab.ru — База знаний">
      <div className="landing-ui-shot__app">
        <div className="kb-hub landing-ui-shot__kb-hub">
          <div className="kb-hub__toolbar">
            <span className="kb-hub__tab kb-hub__tab--active">
              <EditOutlinedIcon fontSize="small" /> Редактор
            </span>
            <span className="kb-hub__tab">
              <SettingsOutlinedIcon fontSize="small" /> Настройки
            </span>
          </div>

          <div className="kb-hub__meta">
            <span className="kb-hub__meta-path">
              Монтаж на объекте / <strong>Безопасность</strong>
            </span>
            <span className="kb-hub__meta-stat">12 вопросов готово</span>
          </div>

          <div className="kb-hub__workspace">
            <section className="kb-hub__panel landing-ui-shot__kb-panel">
              <div className="kb-hub__layout kb-hub__layout--three landing-ui-shot__kb-layout">
                <aside className="kb-hub__col kb-hub__col--roots">
                  <div className="kb-hub__col-head">
                    <h3 className="kb-hub__col-title">Основные темы</h3>
                  </div>
                  <ul className="kb-hub__list">
                    <KbTopicItem label="Монтаж" active />
                    <KbTopicItem label="Документы" />
                  </ul>
                  <span className="landing-ui-shot__btn landing-ui-shot__btn--block">
                    <AddIcon fontSize="small" /> Тема
                  </span>
                </aside>

                <aside className="kb-hub__col kb-hub__col--subtopics">
                  <div className="kb-hub__col-head">
                    <h3 className="kb-hub__col-title">Подтемы</h3>
                  </div>
                  <p className="kb-hub__col-context">
                    Тема: <strong>Монтаж</strong>
                  </p>
                  <ul className="kb-hub__list">
                    <KbTopicItem label="Безопасность" active />
                    <KbTopicItem label="Кабели" />
                  </ul>
                  <span className="landing-ui-shot__btn landing-ui-shot__btn--block">
                    <AddIcon fontSize="small" /> Подтема
                  </span>
                </aside>

                <section className="kb-hub__col kb-hub__col--questions">
                  <div className="kb-hub__col-head">
                    <h3 className="kb-hub__col-title">Вопросы и ответы</h3>
                  </div>
                  <p className="kb-hub__col-context">
                    Подтема: <strong>Безопасность</strong>
                  </p>
                  <div className="landing-ui-shot__field">
                    <label>Вопрос</label>
                    <div className="landing-ui-shot__input">
                      Какой кабель использовать для блока питания?
                    </div>
                  </div>
                  <div className="landing-ui-shot__mode">
                    <span className="landing-ui-shot__mode-btn landing-ui-shot__mode-btn--active">
                      <TextFieldsOutlinedIcon fontSize="small" /> Текст
                    </span>
                    <span className="landing-ui-shot__mode-btn">
                      <VideocamOutlinedIcon fontSize="small" /> Видео
                    </span>
                  </div>
                  <div className="landing-ui-shot__field">
                    <label>Ответ</label>
                    <div className="landing-ui-shot__textarea">
                      Используйте кабель ВВГнг 3×2,5 мм². Проверьте маркировку на бухте
                      и заземление перед включением.
                    </div>
                  </div>
                </section>
              </div>
            </section>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
}

export function ScenarioEditorShot() {
  return (
    <BrowserFrame title="club-lab.ru — Сценарий">
      <div className="landing-ui-shot__app landing-ui-shot__app--scenario">
        <div className="landing-ui-shot__tabs">
          <span className="landing-ui-shot__tab landing-ui-shot__tab--active">
            <EditOutlinedIcon fontSize="small" /> Карта сцен
          </span>
          <span className="landing-ui-shot__tab">Настройки</span>
        </div>
        <div className="landing-ui-shot__scenario-canvas">
          <div className="landing-ui-shot__scenario-group">
            <div className="landing-ui-shot__scenario-group-label">
              Сцена 1 · Приветствие
              <span className="landing-ui-shot__scenario-type">Текст</span>
            </div>
            <div className="landing-ui-shot__scenario-scene landing-ui-shot__scenario-scene--text">
              <p className="landing-ui-shot__scenario-text">
                Добро пожаловать в программу адаптации! Сегодня вы познакомитесь с
                командой, рабочими процессами и правилами сервиса.
              </p>
            </div>
            <div className="landing-ui-shot__scenario-buttons">
              <span>Дальше по регламенту</span>
              <span>Задать вопрос HR</span>
            </div>
          </div>
          <div className="landing-ui-shot__scenario-arrow" />
          <div className="landing-ui-shot__scenario-group landing-ui-shot__scenario-group--alt">
            <div className="landing-ui-shot__scenario-group-label">
              Сцена 2 · Касса
              <span className="landing-ui-shot__scenario-type landing-ui-shot__scenario-type--video">
                Видео
              </span>
            </div>
            <div className="landing-ui-shot__scenario-scene">
              <div className="landing-ui-shot__scenario-video">
                <span className="landing-ui-shot__scenario-play" aria-hidden="true">
                  <PlayArrowRoundedIcon />
                </span>
              </div>
              <p>Клиент просит возврат без чека</p>
            </div>
            <div className="landing-ui-shot__scenario-buttons">
              <span>Предложить обмен</span>
              <span>Вызвать старшего</span>
            </div>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
}

export function TrainerEditorShot() {
  return (
    <BrowserFrame title="club-lab.ru — Тренажёр">
      <div className="landing-ui-shot__app">
        <div className="landing-ui-shot__trainer">
          <div className="landing-ui-shot__tabs">
            <span className="landing-ui-shot__tab landing-ui-shot__tab--active">
              <EditOutlinedIcon fontSize="small" /> Вопросы
            </span>
            <span className="landing-ui-shot__tab">Настройки</span>
          </div>

          <div className="landing-ui-shot__meta">
            <span>
              Тема: <strong>Продуктовые знания</strong>
            </span>
            <span>8 вопросов</span>
          </div>

          <div className="landing-ui-shot__trainer-layout">
            <div className="landing-ui-shot__trainer-nav">
              <button type="button" className="landing-ui-shot__q-item landing-ui-shot__q-item--active">
                1. Какой тариф подходит новому клиенту?
              </button>
              <button type="button" className="landing-ui-shot__q-item">
                2. Что делать при возражении «дорого»?
              </button>
              <button type="button" className="landing-ui-shot__q-item">
                3. Как оформить пробный доступ?
              </button>
            </div>

            <div className="landing-ui-shot__trainer-detail">
              <div className="landing-ui-shot__field">
                <label>Вопрос</label>
                <div className="landing-ui-shot__input">
                  Какой тариф подходит новому клиенту?
                </div>
              </div>
              <div className="landing-ui-shot__answers">
                <label className="landing-ui-shot__answer landing-ui-shot__answer--ok">
                  <CheckCircleOutlineIcon fontSize="small" /> Базовый — до 15 сотрудников
                </label>
                <label className="landing-ui-shot__answer">Расширенный</label>
                <label className="landing-ui-shot__answer">Корпоративный</label>
              </div>
              <span className="landing-ui-shot__btn landing-ui-shot__btn--ghost">
                <AddIcon fontSize="small" /> Добавить ответ
              </span>
            </div>
          </div>
        </div>
      </div>
    </BrowserFrame>
  );
}

const SHOTS = {
  knowledge_base: KnowledgeBaseEditorShot,
  scenario: ScenarioEditorShot,
  trainer: TrainerEditorShot,
};

export default function LandingEditorScreenshot({ type }) {
  const Shot = SHOTS[type] ?? KnowledgeBaseEditorShot;
  return <Shot />;
}
